import { render, staticRenderFns } from "./Complements.vue?vue&type=template&id=a54347ac"
import script from "./Complements.vue?vue&type=script&lang=js"
export * from "./Complements.vue?vue&type=script&lang=js"
import style0 from "./Complements.vue?vue&type=style&index=0&id=a54347ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports